export default "__VITE_ASSET__DZOKpMgC__"